import type { CookieSetOptions } from 'universal-cookie';
import {
  deleteCookie as removeCookie,
  getCookie as readCookie,
  setCookie as writeCookie,
} from '@dx-ui/utilities-cookies';

const VALID_SAME_SITES = ['none', 'lax', 'strict'];

function getDefaultDomain() {
  return location.hostname === 'localhost' ? 'localhost' : '.hilton.com';
}

export const setCookie = (
  name: string,
  value: string,
  expires: number | null,
  path = '',
  domain = 'hilton.com',
  secure = true,
  escape = true,
  sameSite = 'lax'
) => {
  if (undefined === domain) {
    domain = getDefaultDomain();
  }

  if (sameSite !== 'lax' && sameSite !== null) {
    sameSite = sameSite.toLowerCase();

    if (!VALID_SAME_SITES.includes(sameSite)) {
      throw new TypeError(`sameSite must be one of the following: ${VALID_SAME_SITES}`);
    }
  }

  const cookieValue = escape ? encodeURIComponent(value) : value;
  const options: CookieSetOptions = {
    ...(path ? { path } : {}),
    ...(domain ? { domain } : {}),
    ...(secure ? { secure } : {}),
    ...(sameSite ? { sameSite: sameSite as CookieSetOptions['sameSite'] } : {}),
  };

  if (expires) {
    const expiresInMs = expires * 24 * 60 * 60 * 1000;
    options.expires = new Date(Date.now() + expiresInMs);
  }

  writeCookie(name, cookieValue, options);
};

export const getCookie = (cname: string) => {
  const cookie = readCookie(cname);
  if (typeof cookie === 'string') {
    try {
      return decodeURIComponent(cookie);
    } catch {
      return cookie;
    }
  }

  return cookie ? String(cookie) : '';
};

export const deleteCookie = (name: string, path: string, domain?: string) => {
  if (undefined === domain) {
    domain = getDefaultDomain();
  }

  if (getCookie(name)) {
    removeCookie(name, {
      ...(path ? { path } : {}),
      ...(domain ? { domain } : {}),
    });
  }
};
